import { useSelector } from 'react-redux';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import { ReactComponent as ArrowUpRight } from '../../../assets/icons/ArrowUpRight.svg';
import Context from '../../../store/context';
import { paths } from '../../../routes';
import useGet from '../../../services/hooks/http/useGet';
import apiMethods from '../../../apis';
import utils from '../../../services/utils';
import DetailsCollaborator from '../../Details/DetailsCollaborator/DetailsCollaborator';
import DetailsCollaborators from './DetailsCollaborators/DetailsCollaborators';
import HeadPay from '../../ResultPay/HeadPay/HeadPay';
import CollaboratorsResult from '../../ResultPay/CollaboratorsResult/CollaboratorsResult';
import NoticeCard from '../../NoticeCard/NoticeCard';
import Button from '../../Buttons/Button/Button';

import classes from './ResultPayPayroll.module.scss';

const ResultPayPayroll = ({ payPayrollData, route, methodForPay, costTransaction }) => {
  const navigate = useNavigate();
  const {
    modal: { showModal, showError }
  } = useContext(Context);

  const goPayrollsView = () => {
    if (!!!route) {
      navigate(`${paths.payrolls}#myCollaborators#inProcess`);
      return;
    }
    if (route !== paths.payrolls) {
      const url = `/collaborator/${route}`;
      navigate(`${url}#myCollaborators#inProcess`);
    } else {
      navigate(`${paths.payrolls}#myCollaborators#inProcess`);
    }
  };

  const { businessId } = useSelector(state => state.userData);

  const [fetchGetState, setFetchGetState] = useState(false);

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getPayrollPayoutVoucher, [businessId, payPayrollData.payoutId], fetchGetState);

  const downloadVoucher = () => {
    setFetchGetState(true);
  };

  useEffect(() => {
    if (getPayedVoucherSuccess) {
      utils.downloadFileByUrl(getPayedVoucher);
      setFetchGetState(false);
    } else if (getPayedVoucherError) {
      showError({ title: 'Descargar comprobante', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  const showCollaborators = () => {
    showModal(
      <DetailsCollaborators
        totalValueCollaborators={payPayrollData.subtotalValue}
        collaborators={payPayrollData.payouts}
        payoutId={payPayrollData.payoutId}
        methodForPay={methodForPay}
      />
    );
  };

  const showDetailsCollaboratorUnique = collaborator => {
    showModal(<DetailsCollaborator collaborator={collaborator} methodForPay={methodForPay} />);
  };

  return (
    <div>
      <HeadPay totalToPay={payPayrollData.totalValue} text={`${payPayrollData.totalCollaborators} colaboradores`} />
      <div className={`${classes.card} card-formGrid`}>
        <CollaboratorsResult
          methodForPay={methodForPay}
          payPayrollData={payPayrollData}
          showCollaborators={showCollaborators}
          showDetailsCollaboratorUnique={showDetailsCollaboratorUnique}
          costTransaction={costTransaction}
        />

        <NoticeCard
          className={classes.notice}
          text='Una vez el pago sea aprobado (máx. 1 día hábil), automáticamente se te enviará y a los colaboradores un correo de confirmación del pago con los detalles.'
        />
      </div>
      <div className={classes.buttons}>
        <Button onClick={downloadVoucher} Icon={ArrowDownLine}>
          Descargar comprobante
        </Button>
        <Button className={classes.button} Icon={ArrowUpRight} custom='secondary' onClick={goPayrollsView}>
          Ir a Pagos en proceso
        </Button>
      </div>
    </div>
  );
};

export default ResultPayPayroll;
